import { render, staticRenderFns } from "./personnelSelection.vue?vue&type=template&id=63bd8b85&scoped=true"
import script from "./personnelSelection.vue?vue&type=script&lang=js"
export * from "./personnelSelection.vue?vue&type=script&lang=js"
import style0 from "./personnelSelection.vue?vue&type=style&index=0&id=63bd8b85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bd8b85",
  null
  
)

export default component.exports